import { ChangeDetectionStrategy, Component, Resource, signal } from '@angular/core';
import { LoadingSpinnerComponent } from '@softline/ui-core';
import type { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import type { ILoadingOverlayParams } from 'ag-grid-enterprise';
import { ResourceContainerComponent } from '@softapps/core';

@Component({
  selector: 'soft-grid-loading',
  imports: [ResourceContainerComponent, LoadingSpinnerComponent],
  template: `
    @if (resource(); as res) {
      <soft-resource-container [resource]="res" />
    } @else {
      <soft-ds-loading-spinner size="xl" color="primary" />
    }
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridLoadingOverlay implements ILoadingOverlayAngularComp {
  readonly resource = signal<Resource<any> | undefined>(undefined);

  agInit(params: ILoadingOverlayParams<any, any> & { dataSource?: Resource<any> }): void {
    this.resource.set(params.dataSource);
  }
  refresh?(
    params: ILoadingOverlayParams<any, any> & { dataSource?: Resource<any> }
  ): void {
    this.resource.set(params.dataSource);
  }
}
